import React from 'react';
import Button from '../../../components/ui/Button';
import Icon from '../../../components/AppIcon';

const DeleteConfirmModal = ({ 
  isOpen, 
  onClose, 
  onConfirm, 
  quote = null, 
  selectedQuotes = [], 
  isDeleting = false 
}) => {
  if (!isOpen) return null;

  const isMultiple = selectedQuotes?.length > 0;
  const count = isMultiple ? selectedQuotes?.length : 1;
  const quoteName = quote ? `${quote?.quoteNumber} (${quote?.client?.name} ${quote?.client?.surname})` : '';

  return (
    <div className="fixed inset-0 z-50 overflow-y-auto">
      <div className="flex items-center justify-center min-h-screen px-4 pt-4 pb-20 text-center sm:block sm:p-0">
        {/* Background overlay */}
        <div 
          className="fixed inset-0 transition-opacity bg-black bg-opacity-50"
          onClick={onClose}
        />

        {/* Modal panel */}
        <div className="inline-block w-full max-w-md p-6 my-8 overflow-hidden text-left align-middle transition-all transform bg-surface shadow-xl rounded-lg">
          {/* Icon */}
          <div className="flex items-center justify-center w-12 h-12 mx-auto mb-4 bg-error/10 rounded-full">
            <Icon name="AlertTriangle" size={24} className="text-error" />
          </div>

          {/* Content */}
          <div className="text-center">
            <h3 className="text-lg font-medium text-text-primary mb-2">
              Confirmer la suppression
            </h3>
            <p className="text-sm text-text-secondary mb-6">
              {isMultiple ? (
                <>
                  Êtes-vous sûr de vouloir supprimer {count} devis sélectionnés ? 
                  Cette action est irréversible.
                </>
              ) : (
                <>
                  Êtes-vous sûr de vouloir supprimer le devis <strong>{quoteName}</strong> ? 
                  Cette action est irréversible.
                </>
              )}
            </p>
          </div>

          {/* Actions */}
          <div className="flex items-center justify-end space-x-3">
            <Button
              variant="outline"
              onClick={onClose}
              disabled={isDeleting}
            >
              Annuler
            </Button>
            <Button
              variant="destructive"
              iconName="Trash2"
              iconPosition="left"
              onClick={onConfirm}
              loading={isDeleting}
              disabled={isDeleting}
            >
              Supprimer
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DeleteConfirmModal;